import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "meta" }
const _hoisted_2 = {
  class: "order-product-list--header",
  "data-cy": "order-product-header"
}
const _hoisted_3 = { class: "bold" }
const _hoisted_4 = { class: "header-actions" }
const _hoisted_5 = { class: "notice warn text-center space-v2" }
const _hoisted_6 = {
  key: 1,
  class: "selection-hint"
}
const _hoisted_7 = { class: "order-product-list--actions" }
const _hoisted_8 = {
  key: 0,
  class: "package-list--container"
}
const _hoisted_9 = ["onDragover"]
const _hoisted_10 = {
  key: 0,
  class: "meta package-title draft-title"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 2,
  class: "meta"
}
const _hoisted_13 = {
  key: 0,
  class: "packing-options--inner",
  "data-cy": "packing-options-inner"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 1,
  class: "packing-options--palceholder placeholder"
}
const _hoisted_16 = {
  class: "package-products",
  "data-cy": "package-product-container"
}
const _hoisted_17 = {
  key: 0,
  class: "product-issues"
}
const _hoisted_18 = {
  key: 0,
  class: "has-issue"
}
const _hoisted_19 = {
  key: 1,
  class: "has-issue"
}
const _hoisted_20 = ["onClick", "onDragstart", "onDragend"]
const _hoisted_21 = { class: "left" }
const _hoisted_22 = ["data-tooltip"]
const _hoisted_23 = {
  key: 0,
  class: "product-remove-indicator"
}
const _hoisted_24 = { key: 2 }
const _hoisted_25 = { class: "middle" }
const _hoisted_26 = {
  key: 0,
  class: "product-replacement-indicator"
}
const _hoisted_27 = { class: "product-sku" }
const _hoisted_28 = ["data-contents"]
const _hoisted_29 = { class: "right product-weight" }
const _hoisted_30 = { class: "weight-value" }
const _hoisted_31 = {
  key: 1,
  class: "serial_ids"
}
const _hoisted_32 = { class: "serial_id" }
const _hoisted_33 = { class: "order-product-list--actions" }
const _hoisted_34 = { class: "order-product-list--actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_entry_search = _resolveComponent("entry-search")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_form_select = _resolveComponent("form-select")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_quantity_control = _resolveComponent("quantity-control")!
  const _component_ozn_button = _resolveComponent("ozn-button")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("section", {
    class: "order-product-list order-product-list--container",
    onDragover: _cache[4] || (_cache[4] = ($event: any) => (_ctx.dragState.assignTarget = undefined))
  }, [
    (_ctx.productState.show)
      ? (_openBlock(), _createBlock(_component_entry_search, {
          key: 0,
          show: true,
          payload: _ctx.productState.items,
          "query-handler": _ctx.productQueryHandler,
          model: _ctx.searchModel,
          onSelection: _ctx.handleProductSelect,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.productState.show = false)),
          style: {"min-width":"320px","z-index":"99999"}
        }, {
          "search-item-content": _withCtx(({item}) => [
            _createElementVNode("span", _hoisted_1, _toDisplayString(item.sku || ''), 1)
          ]),
          _: 1
        }, 8, ["payload", "query-handler", "model", "onSelection"]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("h6", {
        class: "section-header bold",
        style: _normalizeStyle({display: 'inline-block', marginTop: '1.2rem', color: (_ctx.productState.edit || _ctx.productState.diff) ? 'var(--directr__electric-blue)' : 'var(--directr__dark-slate-blue)'})
      }, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.productState.edit ? 'Editing Products' : `${_ctx.fulfillableProductTotal ? _ctx.parsedPackages?.length : 'No'} ${_ctx.label ? _ctx.label : `${_ctx.parsedPackages?.length === 1 ? 'Package' : 'Packages'}`}`), 1),
        _withDirectives(_createElementVNode("div", { class: "save-error" }, _toDisplayString(_ctx.productState.diff ? (_ctx.shouldCreateReplacement ? 'Order already fulfilled. Create a replacement instead' : '') : 'Please select a reason'), 513), [
          [_vShow, ((_ctx.productState.edit || _ctx.productState.diff) && _ctx.shouldCreateReplacement && (!(_ctx.fulfillableProductTotal - _ctx.selectionState.length) || !(_ctx.productState.replace.reason?.length))) || (_ctx.productState.selection?.length && !(_ctx.productState.replace.reason?.length)) || (_ctx.selectionState.length > 0 && (!(_ctx.fulfillableProductTotal - _ctx.selectionState.length === 0) || !_ctx.shouldCreateReplacement) && !(_ctx.productState.replace.reason?.length))]
        ])
      ], 4),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createVNode(_component_q_btn, {
          unelevated: "",
          rounded: "",
          dense: "",
          onClick: _ctx.handleCancelandReplace,
          "data-cy": "cancel-edit-btn"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.shouldCreateReplacement ? 'Create replacement' : _ctx.productState.diff ? 'Add items' : 'Cancel / Edit items'), 1)
          ]),
          _: 1
        }, 8, ["onClick"]), [
          [_vShow, !(_ctx.productState.edit || _ctx.productState.diff) && !_ctx.readonly]
        ]),
        _withDirectives(_createVNode(_component_q_btn, {
          class: _normalizeClass(["save-action", _ctx.productState.diff ? 'positive' : 'warning']),
          "data-cy": "save-change-btn",
          onClick: _ctx.commitChanges,
          color: _ctx.productState.diff ? 'positive' : 'warning',
          round: _ctx.productState.diff,
          rounded: !_ctx.productState.diff,
          unelevated: "",
          ountline: "",
          dense: "",
          disabled: (_ctx.shouldCreateReplacement && (!(_ctx.fulfillableProductTotal - _ctx.selectionState.length) || !(_ctx.productState.replace.reason?.length))) || (_ctx.productState.selection?.length && !(_ctx.productState.replace.reason?.length)) || (_ctx.selectionState.length > 0 && (!(_ctx.fulfillableProductTotal - _ctx.selectionState.length === 0) || !_ctx.shouldCreateReplacement) && !(_ctx.productState.replace.reason?.length))
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              class: _normalizeClass({'t-icon': _ctx.productState.diff })
            }, _toDisplayString(_ctx.productState.diff ? !(_ctx.fulfillableProductTotal - _ctx.selectionState.length) ? 'j' : 'e' : _ctx.shouldCreateReplacement ? !(_ctx.fulfillableProductTotal - _ctx.selectionState.length) ? 'No products to replace' : 'Create replacement order' : !(_ctx.fulfillableProductTotal - _ctx.selectionState.length) ? 'Cancel order' : 'Save changes'), 3)
          ]),
          _: 1
        }, 8, ["onClick", "color", "class", "round", "rounded", "disabled"]), [
          [_vShow, _ctx.productState.edit || _ctx.productState.diff]
        ]),
        _withDirectives(_createVNode(_component_q_btn, {
          class: "save-action negative",
          round: "",
          unelevated: "",
          dense: "",
          onClick: _ctx.abortCancelandReplace
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [
            _createElementVNode("span", { class: "t-icon" }, "j", -1)
          ])),
          _: 1
        }, 8, ["onClick"]), [
          [_vShow, _ctx.productState.edit || _ctx.productState.diff]
        ])
      ])
    ], 512), [
      [_vShow, _ctx.view !== _ctx.ProductView.Cards]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_5, "Packaging will be recalculated", 512), [
      [_vShow, _ctx.parsedPackages.some(s => s.products?.some(p => p.draft))]
    ]),
    (_ctx.productState.edit)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _withDirectives(_createElementVNode("i", null, "All items cancelled, cannot create replacement with current selection. ", 512), [
            [_vShow, _ctx.fulfillableProductTotal - _ctx.selectionState.length === 0 && _ctx.shouldCreateReplacement]
          ]),
          _withDirectives(_createElementVNode("i", null, "Add products, packing, or click products to cancel ", 512), [
            [_vShow, _ctx.selectionState.length === 0]
          ]),
          _withDirectives(_createElementVNode("i", null, _toDisplayString(_ctx.fulfillableProductTotal - _ctx.selectionState.length === 0 ? 'All' : _ctx.selectionState.length) + " " + _toDisplayString(_ctx.selectionState.length > 1 || _ctx.fulfillableProductTotal - _ctx.selectionState.length === 0 ? 'items' : 'item') + " will be cancelled" + _toDisplayString(_ctx.productState.selection?.length ? ', and ' : ''), 513), [
            [_vShow, _ctx.selectionState.length > 0 && (!(_ctx.fulfillableProductTotal - _ctx.selectionState.length === 0) || !_ctx.shouldCreateReplacement)]
          ]),
          _withDirectives(_createElementVNode("i", null, _toDisplayString(_ctx.productState.selection.length) + " " + _toDisplayString(_ctx.productState.selection.length > 1 ? 'items' : 'item') + " " + _toDisplayString(_ctx.selectionState?.length ? '' : 'will be') + " added", 513), [
            [_vShow, _ctx.productState.selection?.length]
          ])
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_7, [
      (_ctx.productState.edit)
        ? (_openBlock(), _createBlock(_component_form_select, {
            key: 0,
            class: "ozn-input--small replacement-reason-input",
            "model-value": _ctx.productState.replace.reason || '',
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.productState.replace.reason = $event)),
            options: _ctx.replacementReasons,
            label: "Reason",
            type: "tag"
          }, null, 8, ["model-value", "options"]))
        : _createCommentVNode("", true),
      (_ctx.productState.edit && _ctx.shouldCreateReplacement)
        ? (_openBlock(), _createBlock(_component_form_select, {
            key: 1,
            class: "replacement-type-select",
            modelValue: _ctx.productState.replace.type,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.productState.replace.type) = $event)),
            label: "Type",
            type: "select",
            options: _ctx.replacementTypes
          }, null, 8, ["modelValue", "options"]))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, _ctx.view !== _ctx.ProductView.Cards]
    ]),
    _renderSlot(_ctx.$slots, "content", {}, () => [
      (_ctx.view !== _ctx.ProductView.Cards)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("ol", {
              class: _normalizeClass(["package-list", {editing: _ctx.productState.edit || _ctx.productState.diff, wideview: _ctx.itemView === 3 || _ctx.itemView === 1}]),
              "data-cy": "package-list"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parsedPackages, (pack, i) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: _normalizeClass(["package-list-item", {'drag-active': _ctx.dragState.assignTarget === i}]),
                  key: `${pack.title}-${i}-${_ctx.parsedPackages.length}-${pack.components?.map(p => p?.quantity)}`,
                  draggable: false,
                  onDragover: _withModifiers(e => _ctx.drag.over(pack, i, e), ["stop"]),
                  "data-cy": "package-list-item"
                }, [
                  _createVNode(_component_form_select, {
                    class: "packing-type--container",
                    "model-value": {label: pack.name, value: pack},
                    type: "select",
                    options: _ctx.packingOptions,
                    onSelect: e => _ctx.updatePackingItem(pack, i, e)
                  }, {
                    "multi-select": _withCtx(({data,label,options, actions}) => [
                      ((pack.products.length === 1 && pack.products.some(s => s.draft)))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Drafted item"))
                        : (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            class: "meta package-title",
                            onClick: ($event: any) => (_ctx.togglePackingOptions(pack.id+i)),
                            "data-cy": "package-title"
                          }, _toDisplayString((_ctx.capitalize(data.value.name) || `Package ${i + 1}`)), 9, _hoisted_11)),
                      (!(pack.products.length === 1 && pack.products.some(s => s.draft)))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, " — " + _toDisplayString(pack.dimensions?.x) + "x" + _toDisplayString(pack.dimensions?.y) + "x" + _toDisplayString(pack.dimensions?.z), 1))
                        : _createCommentVNode("", true),
                      (!(pack.products.length === 1 && pack.products.some(s => s.draft)))
                        ? (_openBlock(), _createBlock(_component_q_menu, {
                            key: 3,
                            class: "packing-options--container",
                            offset: [0,0],
                            anchor: "bottom left",
                            "max-width": "320px",
                            "transition-duration": "100"
                          }, {
                            default: _withCtx(() => [
                              (options?.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options, (option, o) => {
                                      return _withDirectives((_openBlock(), _createElementBlock("div", {
                                        class: _normalizeClass(["packing-option", {active: pack.name === option.label}]),
                                        onClick: ($event: any) => (actions.emitSelect(option))
                                      }, [
                                        _createTextVNode(_toDisplayString(option.label), 1)
                                      ], 10, _hoisted_14)), [
                                        [_directive_close_popup]
                                      ])
                                    }), 256))
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_15, "..."))
                            ]),
                            _: 2
                          }, 1024))
                        : (_openBlock(), _createBlock(_component_q_menu, {
                            key: 4,
                            class: "packing-options--container",
                            offset: [0,0],
                            anchor: "bottom left",
                            "max-width": "320px",
                            "transition-duration": "100"
                          }, {
                            default: _withCtx(() => _cache[6] || (_cache[6] = [
                              _createElementVNode("div", {
                                class: "packing-options--inner",
                                "data-cy": "packing-options-inner"
                              }, [
                                _createElementVNode("div", { class: "placeholder" }, "Packaging for these items will be recalculated on save")
                              ], -1)
                            ])),
                            _: 1
                          }))
                    ]),
                    _: 2
                  }, 1032, ["model-value", "options", "onSelect"]),
                  _createElementVNode("div", _hoisted_16, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pack.components, (product, n) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "package-product-item--container",
                        key: `product-${pack?.id}-${product?.id}-${product.quantity}-${i}-${n}-${_ctx.id}`
                      }, [
                        (_ctx.showIssues)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              (!product.sku && !product.ean)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_18, "Item has no SKU or EAN"))
                                : _createCommentVNode("", true),
                              (!product.quantity)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_19, "Item quantity is invalid"))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", {
                          class: _normalizeClass(["package-product-item", {selected: _ctx.isSelected(product), cancelled: product?.parent?.status === _ctx.Status.Cancelled}]),
                          onClick: ($event: any) => (_ctx.toggleSelection(product)),
                          draggable: true,
                          onDragstart: _withModifiers(e => _ctx.drag.start(product, i, n, e), ["stop"]),
                          onDragend: _withModifiers(e => _ctx.drag.end(product, i, e), ["stop"])
                        }, [
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["product-quantity has-tooltip", { [_ctx.statusMap[product?.parent?.status || product.status || 'draft']]: true }]),
                              "data-tooltip": (!product?.parent?.status && !product.status) ? 'Unknown Status' : _ctx.formatStatus(product?.parent?.status || product.status, 'customLabel')
                            }, [
                              (product.parent?.replacement && product.parent?.draft)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                    _createVNode(_component_q_btn, {
                                      size: "sm",
                                      style: {"color":"#7ea3ff","transform":"translate(-7px, -3px)","height":"9px"},
                                      flat: "",
                                      round: "",
                                      dense: "",
                                      icon: 'svguse:icons/essential/17-minus-circle.svg',
                                      onClick: ($event: any) => (_ctx.toggleSelection(product))
                                    }, null, 8, ["onClick"])
                                  ]))
                                : (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    class: _normalizeClass(["product-select-indicator", {selected: _ctx.isSelected(product)}])
                                  }, null, 2)),
                              (!(product.parent?.replacement && product.parent?.draft))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(product.quantity), 1))
                                : (product.parent?.replacement && product.parent?.draft)
                                  ? (_openBlock(), _createBlock(_component_quantity_control, {
                                      key: 3,
                                      modelValue: _ctx.parsedPackages[i].products[n].quantity,
                                      "onUpdate:modelValue": [($event: any) => ((_ctx.parsedPackages[i].products[n].quantity) = $event), q => _ctx.updateProductQuantity(_ctx.parsedPackages[i].products[n],  q)],
                                      "control-size": 5,
                                      min: 1
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                  : _createCommentVNode("", true)
                            ], 10, _hoisted_22)
                          ]),
                          _createElementVNode("div", _hoisted_25, [
                            (product.parent?.replacement)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_26, "R"))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_27, _toDisplayString(product.sku ? product.sku : (Array.isArray(product.ean) ? product.ean[0] : '...')), 1),
                            _createElementVNode("span", {
                              class: "product-title",
                              "data-contents": `${product.title} (${product.parent?.carrier})`
                            }, _toDisplayString(product.title), 9, _hoisted_28)
                          ]),
                          _withDirectives(_createElementVNode("span", _hoisted_29, [
                            _createElementVNode("span", _hoisted_30, _toDisplayString(product.weight ? parseFloat(product.weight).toFixed(1) : '-'), 1),
                            _cache[7] || (_cache[7] = _createElementVNode("span", { class: "weight-unit" }, "g", -1))
                          ], 512), [
                            [_vShow, !_ctx.isMobile]
                          ])
                        ], 42, _hoisted_20),
                        (product.parent?.serial_id?.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                              _cache[8] || (_cache[8] = _createElementVNode("i", { class: "bold" }, "Serial IDs ", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((typeof product.parent?.serial_id === 'string' ? product.parent?.serial_id.split(',') : product.parent?.serial_id), (id) => {
                                return (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(String(id)), 1))
                              }), 256))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ], 42, _hoisted_9))
              }), 128))
            ], 2),
            _withDirectives(_createElementVNode("div", _hoisted_33, [
              _createVNode(_component_ozn_button, {
                class: "minimal",
                onClick: _ctx.autoSplit,
                "data-cy": "split-btn"
              }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [
                  _createTextVNode("+ Split Packing")
                ])),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_ozn_button, {
                class: "minimal",
                onClick: _ctx.searchProductItem,
                "data-cy": "add-prod-btn"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(!_ctx.isMobile ? '+ Product' : '+'), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ], 512), [
              [_vShow, _ctx.productState.edit]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_34, [
              _createVNode(_component_ozn_button, {
                class: _normalizeClass(["minimal split-package-button", {'drag-active': _ctx.dragState.assignTarget === 'split'}]),
                onDragover: _cache[3] || (_cache[3] = _withModifiers(($event: any) => {_ctx.dragState.assignTarget = 'split'; _ctx.dragState.handler = (p, i, e) => _ctx.setCustomPacking(p, i, e)}, ["stop"]))
              }, {
                default: _withCtx(() => _cache[10] || (_cache[10] = [
                  _createTextVNode("☷ Split into 2 packages")
                ])),
                _: 1
              }, 8, ["class"])
            ], 512), [
              [_vShow, _ctx.dragState.dragging]
            ])
          ]))
        : _createCommentVNode("", true)
    ], true)
  ], 32))
}